import { SupabaseClient} from "../supabaseClient";

export async function getWeeklyInsights(profileId) {
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    const oneWeekAgoDate = oneWeekAgo.toISOString().split('T')[0]; // 'YYYY-MM-DD'
    const { data, error } = await SupabaseClient
        .from('weekly_summaries')
        .select('*')
        .eq('profile_id', profileId)
        .gte('generated_at', oneWeekAgoDate)
        .order('generated_at', { ascending: false })
        .limit(1)
        .single();
    return { data, error }
}

export async function saveWeeklyInsights(profileId, data) {
    const { error: insertError } = await SupabaseClient.from('weekly_summaries').insert({
        profile_id: profileId,
        text: data.text,
        generated_at: new Date().toISOString(),
    })
    return insertError
}